import {twMerge} from '@sdox/utils'

import type {ComponentProps, ReactNode} from 'react'

export interface ListItemProps extends ComponentProps<'li'> {
  icon?: ReactNode
  inset?: boolean
  large?: boolean
}

export const ListItem = ({icon, inset, large, children, className, onClick, ...restProps}: ListItemProps) => (
  <li
    className={twMerge(
      'py-2',
      icon && 'flex items-center gap-4',
      inset && !large && 'px-2',
      inset && large && 'px-4',
      large && 'py-4',
      onClick && 'cursor-pointer select-none hover:bg-gray-100',
      className,
    )}
    onClick={onClick}
    {...restProps}
  >
    {icon && <div>{icon}</div>}
    {children}
  </li>
)
